<template>
  <div>
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.66491 6H12.3351C12.6263 6 12.828 6.1356 12.94 6.4068C13.052 6.67801 13.0072 6.91124 12.8056 7.10651L8.47048 11.3047C8.33605 11.4349 8.17923 11.5 8 11.5C7.82077 11.5 7.66395 11.4349 7.52952 11.3047L3.19443 7.10651C2.9928 6.91124 2.94799 6.67801 3.06001 6.4068C3.17203 6.1356 3.37366 6 3.66491 6Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Caret',
};
</script>
